import styled from "styled-components";
import colors from "../../../../../styles/colorPalette";
import shades from "../../../../../styles/shadesPalette";
import { fadeIn, fadeOut } from "../../../../../styles/animations";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  width: 100%;
  height: 100%;
  font-size: 60px;
  text-align: center;
  background: transparent;
`;

export const Nav = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  position: absolute;
  width: ${(props) => (!props.visible ? "150px" : "340px")};
  min-height: 100%;
  padding: 30px 0px 20px 0px;
  box-sizing: border-box;
  font-size: 20px;
  font-weight: bold;
  color: ${colors.white1};
  cursor: pointer;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  transition: all 0.7s;
  overflow: hidden;
  z-index: 1000;
  box-shadow: ${(props) => (!props.visible ? shades.shadow3 : shades.shadow2)};
  background: ${colors.gray2};
  @media (max-height: 900px) {
    width: ${(props) => (!props.visible ? "100px" : "300px")};
    height: 95.5%;
  }
  @media (max-height: 850px) {
    width: ${(props) => (!props.visible ? "100px" : "270px")};
    height: 95.3%;
  }
  @media (max-height: 750px) {
    width: ${(props) => (!props.visible ? "100px" : "270px")};
    height: 94.5%;
  }
  @media (max-height: 700px) {
    width: ${(props) => (!props.visible ? "100px" : "270px")};
    height: 94%;
  }
`;

export const InitialsIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  min-height: 80px;
  color: ${colors.blue1};
  font-family: "OpenSansRegular";
  font-weight: 800;
  font-size: 30px;
  border: 4px solid ${colors.blue3};
  border-radius: 100px;
  box-sizing: border-box;
  @media (max-height: 900px) {
    min-width: 72px;
    min-height: 72px;
  }
  @media (max-height: 800px) {
    border: 2px solid ${colors.blue3};
  }
  @media (max-width: 1400px) {
    border: 2px solid ${colors.blue3};
    min-width: 50px;
    min-height: 50px;
    font-size: 17px;
  }
`;

export const TopContainerIcons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: right;
  justify-content: ${(props) => (props.isIndexing ? "center" : "start")};
  width: 100%;
  height: 80%;
  padding: 0px 0px 0px 34px;
  margin-right: auto;
  overflow: visible;
  & > * {
    &:first-child {
      margin-bottom: 40px;
    }
    &:not(:first-child) {
      margin-bottom: 25px;
    }
  }
  @media (max-height: 900px) {
    padding-left: 22px;
  }
  @media (max-height: 700px) {
    padding-left: 25px;
    & > * {
      &:first-child {
        margin-bottom: 31px;
      }
    }
  }
`;

export const Field = styled.div`
  color: ${colors.gray3};
  transition: all 0.4s;
  animation: 0.4s ${(props) => (props.isOpen ? fadeIn : fadeOut)} forwards;
  @media (max-height: 850px) {
    font-size: 12px;
  }
  max-width: 200px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: ${(props) => (props.isOpen ? "300px" : "100px")};
  & > * {
    margin-right: 10px;
  }
`;

export const SecondaryRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: ${(props) => (props.isOpen ? "300px" : "80px")};
  & > * {
    margin-right: 10px;
  }
  padding-left: 28px;
  @media (max-width: 1400px) {
    padding-left: 13px;
  }
`;
